import { Button, Form, Row, Col, Spinner } from "reactstrap";

import { ChangeEvent, useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { UserProps, UserToken } from "../../context/hooks/useAuth";
import InputPassword from "../../components/Inputs/InputPassword";
import InputEmailLogin from "../../components/Inputs/InputEmailLogin";
import "./ForgotPassword.css";
import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined";
import { UserTypeContext } from "../../context/UserTypeContext";
import { jwtDecode } from "jwt-decode";
import KeyIcon from '@mui/icons-material/Key';

const ForgotPassword = () => {
  const { handleLogin, sendEmailResetPassword } = useContext(AuthContext);
  const { getUsersById } = useContext(UserTypeContext);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth < 650);

  const [email, setEmail] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handleLoginClick = async () => {
    setLoading(true);
    await sendEmailResetPassword(email);
    setLoading(false);
  };

  const handleInputChange = (valueAtt: any, name: string) => {
    setEmail(valueAtt);
  };

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter") {
      handleLoginClick();
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobileView(window.innerWidth < 650);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      <div style={{ position: "absolute", top: "30px", right: "10px" }}>
        <Button
          onClick={(e) => {
            e.preventDefault();
            window.location.href = "/auth/login";
          }}
          className="button-create-user"
          type="button"
          disabled={loading}
        >
          <Person2OutlinedIcon style={{ color: "#DCAC36" }} />
          Login
        </Button>
      </div>
      <Row className="justify-content-center">
        <Col
          lg="10"
          md="7"
          className="d-flex"
          style={{
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "40px",
            marginTop: "82px"
          }}
        >
          <img
            style={{ width: "50%" }}
            alt="Logo"
            // className="rounded-circle mx-auto d-block mt-3 mb-4"
            src={require("../../assets/img/brand/logoendocpng.png")}
          />

          <div className="d-flex" style={{ flexDirection: "column" }}>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "5.76px",
                color: "#002231",
                opacity: 1,
                fontSize: "24px",
              }}
            >
              Vamos ajudá-lo a redefinir sua senha.{" "}
            </span>
            <span
              style={{
                textAlign: "center",
                letterSpacing: "2.24px",
                color: "#002231",
                opacity: 0.5,
                fontSize: "11px",
              }}
            >
              Digite seu e-mail no campo abaixo. Você receberá um link para
              redefinir sua senha.{" "}
            </span>
          </div>

          <div className="px-lg-5" style={{ width: "84%" }}>
            <Form
              role="form"
              style={{
                gap: "27px",
                display: "flex",
                flexDirection: "column",
                width: "100%",
              }}
            >
              <InputEmailLogin
                name="email"
                value={email}
                handleChange={handleInputChange}
                label={"E-mail"}
                onKeyDown={handleKeyDown}
              />
            </Form>
            <div className="text-center d-flex justify-content-center">
              <Button
                onClick={handleLoginClick}
                className="my-4 button-login"
                type="button"
                disabled={loading}
              >
                {loading ? (
                  <Spinner size="sm">Loading...</Spinner>
                ) : (
                  <KeyIcon />
                )}{" "}
                Enviar E-mail
              </Button>
            </div>
          </div>

          <div
            style={{
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.preventDefault();
              window.location.href = "/auth/register";
            }}
          >
            <span
              style={{
                textAlign: "center",
                color: "#000",
                fontSize: "13px",
              }}
            >
              Ainda não tem conta?{" "}
            </span>
            <span
              style={{
                textAlign: "center",
                color: "#F9B233",
                fontSize: "13px",
              }}
            >
              Crie uma gratuitamente!
            </span>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default ForgotPassword;
